export class ResourceContractorSchemaListRequest {

    // DocumentSchemaCriteria {
    //     criteria: {
    //         term: string
    //         page: number
    //         document_schema_type_ids: number[]
    //     }
    // }

    _documentSchemaType; // number

    constructor(documentSchemaType) {
        this._documentSchemaType = documentSchemaType;
    }

    body() {
        return {
            criteria: {
                term: undefined,
                page: undefined,
                document_schema_type_ids: [this._documentSchemaType],
                skip_contractors_inactive: true
            },
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchemaListRequest.js